import {
  FETCH_LOGS,
  FETCH_LOG_BY_ID,
  FETCH_LOG_STATS,
  CLEANUP_LOGS,
  LIMPIAR_ESTADO_LOGS
} from '../actions/types';

const initialState = {
  logs: [],
  logDetail: null,
  stats: null,
  loading: false,
  error: null,
  total: 0,
  filters: {},
  pagination: {
    current: 1,
    pageSize: 10
  }
};

const logsReducer = (state = initialState, action) => {
  // console.log('logsReducer action:', action.type, action);
  
  switch (action.type) {
    case `${FETCH_LOGS}_PENDING`:
      // console.log('FETCH_LOGS_PENDING triggered');
      return {
        ...state,
        loading: true,
        error: null
      };
    case `${FETCH_LOGS}_FULFILLED`:
      // console.log('FETCH_LOGS_FULFILLED payload:', action.payload);
      // console.log('Logs data:', action.payload.data);
      return {
        ...state,
        loading: false,
        logs: action.payload.data.data || action.payload.data.logs || action.payload.data || [],
        total: action.payload.data.total || action.payload.data.count || 0,
        error: null
      };
    case `${FETCH_LOGS}_REJECTED`:
      console.error('FETCH_LOGS_REJECTED:', action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload.response?.data?.message || 'Error al cargar logs',
        logs: []
      };

    case `${FETCH_LOG_BY_ID}_PENDING`:
      return {
        ...state,
        loading: true,
        error: null
      };
    case `${FETCH_LOG_BY_ID}_FULFILLED`:
      return {
        ...state,
        loading: false,
        logDetail: action.payload.data,
        error: null
      };
    case `${FETCH_LOG_BY_ID}_REJECTED`:
      return {
        ...state,
        loading: false,
        error: action.payload.response?.data?.message || 'Error al cargar log',
        logDetail: null
      };

    case `${FETCH_LOG_STATS}_PENDING`:
      // console.log('FETCH_LOG_STATS_PENDING triggered');
      return {
        ...state,
        loading: true,
        error: null
      };
    case `${FETCH_LOG_STATS}_FULFILLED`:
      return {
        ...state,
        loading: false,
        stats: action.payload.data,
        error: null
      };
    case `${FETCH_LOG_STATS}_REJECTED`:
      console.error('FETCH_LOG_STATS_REJECTED:', action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload.response?.data?.message || 'Error al cargar estadísticas',
        stats: null
      };

    case `${CLEANUP_LOGS}_PENDING`:
      return {
        ...state,
        loading: true,
        error: null
      };
    case `${CLEANUP_LOGS}_FULFILLED`:
      return {
        ...state,
        loading: false,
        error: null
      };
    case `${CLEANUP_LOGS}_REJECTED`:
      return {
        ...state,
        loading: false,
        error: action.payload.response?.data?.message || 'Error al limpiar logs'
      };

    case LIMPIAR_ESTADO_LOGS:
      return initialState;

    default:
      return state;
  }
};

export default logsReducer;
